"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_native_1 = require("react-native");
var Text_1 = __importDefault(require("./Text"));
var hooks_1 = require("./hooks");
(function () {
    if (react_native_1.Platform.OS !== 'web')
        return;
    var style = document.createElement('style');
    style.textContent = "textarea, select, input, button { outline: none!important; }";
    document.head.append(style);
})();
var Input = function (props) {
    var placeholder = props.placeholder, multiLines = props.multiLines, onSubmitEditing = props.onSubmitEditing, onEnter = props.onEnter, inputProps = props.inputProps, onHoverStyle = props.onHoverStyle, onResponsiveStyle = props.onResponsiveStyle, placeholderColor = props.placeholderColor;
    var _a = react_1.useState(props.value), value = _a[0], setValue = _a[1];
    var style = hooks_1.usePropsStyle(props);
    var compRef = react_1.useRef();
    var onRef = function (ref) {
        if (!ref)
            return;
        compRef.current = ref;
        if (props.onRef)
            props.onRef(ref);
    };
    var useNativeStyleProps = props.useNativeStyleProps === false ? false : true;
    var _b = hooks_1.useHoverStyle(onHoverStyle, useNativeStyleProps, style, compRef), hoverProps = _b[0], combinedStyle = _b[1];
    var responsiveStyle = hooks_1.useResponsiveStyle(onResponsiveStyle);
    var handleChange = function (newText) {
        if (props.onChange)
            props.onChange(newText);
        else
            setValue(newText);
    };
    react_1.useEffect(function () {
        setValue(props.value);
    }, [props.value]);
    react_1.useEffect(function () {
        if (!props.id)
            return;
        Input.instances[props.id] = {
            get: function () { return value; },
            set: function (newValue) { return setValue(newValue); },
            focus: function () { return !!compRef.current && compRef.current.focus(); },
            isFocused: function () { return !!compRef.current && compRef.current.isFocused(); },
            blur: function () { return !!compRef.current && compRef.current.blur(); },
        };
        return function () {
            if (props.id)
                delete Input.instances[props.id];
        };
    }, [props.id, value]);
    var inputStyle = [Text_1.default.defaultFont, combinedStyle, responsiveStyle];
    return react_1.useMemo(function () {
        return (react_1.default.createElement(react_native_1.TextInput, __assign({ value: String(value), autoCapitalize: "none", onChangeText: handleChange, underlineColorAndroid: "transparent", placeholderTextColor: placeholderColor || Text_1.default.defaultFont.color, placeholder: placeholder, ref: onRef, textAlignVertical: "top", multiline: multiLines, onSubmitEditing: onSubmitEditing || onEnter }, hoverProps, inputProps, { style: inputStyle })));
    }, [value, inputStyle, placeholder, placeholderColor, multiLines, onSubmitEditing, onEnter, hoverProps, inputProps]);
};
Input.instances = {};
Input.query = function (id) {
    return Input.instances[id] || null;
};
exports.default = Input;
//# sourceMappingURL=Input.js.map